import React, { useState } from 'react';

import styled from '@emotion/styled';

import { mmddyyyyDate } from '../../utils/utils';

// import FilterIcon from '../Icons/FilterIcon';
// import PrinterIcon from '../Icons/PrinterIcon';

interface ITableDateSearchForm {
  setSearchQuery: (...args: any[]) => void;
  setFromDateQuery: (...args: any[]) => void;
  setToDateQuery: (...args: any[]) => void;
}

const TableDateSearchForm: React.FC<ITableDateSearchForm> = ({
  setSearchQuery,
  setFromDateQuery,
  setToDateQuery,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  let debounceTimer: any;

  const handleSearchTermChange = (e: any) => {
    const value = e.target.value;
    clearTimeout(debounceTimer);
    setSearchTerm(value);
    debounceTimer = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  };

  const handleChangeFromDate = (e: any) => {
    const selectedDate = e.target.value;
    setFromDate(selectedDate);
    setFromDateQuery(mmddyyyyDate(selectedDate));
  };

  const handleChangeToDate = (e: any) => {
    const selectedDate = e.target.value;
    setToDate(selectedDate);
    setToDateQuery(mmddyyyyDate(selectedDate));
  };

  return (
    <Container>
      <Form>
        <InputWrapper>
          <InputLabel htmlFor="search">Search here</InputLabel>
          <TableSearchInputField
            placeholder={'Search Anything'}
            onChange={handleSearchTermChange}
            value={searchTerm}
            id="search"
          />
        </InputWrapper>
        <Vline></Vline>
        <InputWrapper>
          <InputLabel htmlFor="fromDate">From</InputLabel>
          <DateInputField
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={handleChangeFromDate}
          />
        </InputWrapper>
        <InputWrapper>
          <InputLabel htmlFor="toDate">To</InputLabel>
          <DateInputField
            type="date"
            id="toDate"
            value={toDate}
            onChange={handleChangeToDate}
          />
        </InputWrapper>
      </Form>
      {/* <SmallIcon>
        <PrinterIcon />
        <FilterIcon />
        <PrinterIcon />
      </SmallIcon> */}
    </Container>
  );
};

export default TableDateSearchForm;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 2px solid red; */
  width: 100%;
`;

const Vline = styled.div`
  width: 1.5px;
  background-color: ${({ theme }) => theme.palette.borderLineColor};
  height: 50%;
  border-radius: 1px;
  margin-bottom: 0.5rem;
  align-self: last baseline;
`;

const Form = styled.form`
  display: flex;
  gap: 1rem;
`;

// const SmallIcon = styled.div`
//   display: flex;
//   align-items: flex-end;
//   gap: 1rem;
//   color: black;
// `;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableSearchInputField = styled.input`
  display: flex;
  border: 1px solid #c2bebc;
  /* border: 2px solid green; */
  border-radius: 0.25rem;
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondaryText};
  font-size: 1rem;
  height: 48px;
  cursor: text;
  width: 19.25rem;
  /* appearance: none; */

  &:focus {
    outline: none;
    border-color: #f46f3b;
    /* background-color: ${({ theme }) =>
      theme.palette.inputFieldFocusColor}; */
  }
  &:hover {
    cursor: text;
  }

  &::placeholder {
    color: #867c79;
    opacity: 1;
    font-weight: 400;
  }
`;

const DateInputField = styled.input`
  display: flex;
  border: 1px solid #c2bebc;
  /* border: 2px solid green; */
  border-radius: 0.25rem;
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondaryText};
  font-size: 1rem;
  height: 48px;
  cursor: text;
  /* width: 19.25rem; */
  /* appearance: none; */

  &:focus {
    outline: none;
    border-color: #f46f3b;
    /* background-color: ${({ theme }) =>
      theme.palette.inputFieldFocusColor}; */
  }
  &:hover {
    cursor: text;
  }

  &::placeholder {
    color: #867c79;
    opacity: 1;
    font-weight: 400;
  }
`;

export const InputLabel = styled.label`
  /* font-weight: 400; */
  font-size: 0.7rem;
  /* color: #867c79; */
`;
